export default __webpack_public_path__ + "static/media/usa.c874a1df.svg";